import React from "react";
import { Link } from "react-router-dom";
import "./jobStatuses-view.css";
import "../../styles/page-common.css";
import "../../styles/calendar-glass.css";
import { colors } from "../../theme";
import SpinnerView from "../../components/spinner/spinner-view";
import Appointment from "../../components/appointment";
import Planner from "../../components/planner";
import moment from "moment";

class HomeView extends React.Component {
  setUsers = () => {
    if (this.props.company && this.props.company.users) {
      return this.props.company.users.filter((u) => !u.disabled);
    } else return [];
  };

  setStatuses = () => {
    if (this.props.templates) {
      return [
        ...new Set(
          this.props.templates
            .filter((x) => !!x.statuses)
            .flatMap((x) =>
              x.statuses.filter((x) => !x.hide).map((y) => y.name)
            )
        ),
      ];
    } else return [];
  };

  state = {
    selectedTempIndex: [0],
    selectedIndex: 0,
    search: "",
    showAdd: false,
    showCal: "list",
    activeJobs: [],
    selectedUsers: this.setUsers(),
    selectedStatuses: this.setStatuses(),
    sortBy: "importance",
    savedScrollPositions: {},
    savedHorizontalScroll: 0,
  };
  updateTempIndex = (index) => {
    if (this.state.showCal == "list") {
      this.setState({ selectedTempIndex: [index] });
    } else {
      let t = [...this.state.selectedTempIndex];

      if (this.state.selectedTempIndex.includes(index)) {
        t = t.filter((i) => i != index);
        if (t.length == 0) t = [index];
      } else t.push(index);

      this.setState({ selectedTempIndex: t });
    }
  };

  updateSelectedStatuses = (selectedStatus) => {
    let selectedStatuses = [...this.state.selectedStatuses];
    let i = this.state.selectedStatuses.findIndex((o) => o == selectedStatus);
    if (i >= 0) {
      selectedStatuses.splice(i, 1);
    } else {
      selectedStatuses.push(selectedStatus);
    }

    this.setState({ selectedStatuses });
  };

  toggleSelectedStatuses = () => {
    if (this.state.selectedStatuses.length > 0) {
      this.setState({ selectedStatuses: [] });
    } else {
      this.setState({ selectedStatuses: this.setStatuses() });
    }
  };

  updateSelectedUsers = (selectedUserId) => {
    if (this.state.showCal == "planner") {
      this.setState({
        selectedUsers: [
          this.props.company.users.find((i) => i.userId == selectedUserId),
        ],
      });
    } else {
      let selectedUsers = [...this.state.selectedUsers];
      let i = this.state.selectedUsers.findIndex(
        (o) => o.userId == selectedUserId
      );
      if (i >= 0) {
        selectedUsers.splice(i, 1);
      } else {
        selectedUsers.push(
          this.props.company.users.find((i) => i.userId == selectedUserId)
        );
      }

      this.setState({ selectedUsers });
    }
  };

  toggleSelectedUsers = () => {
    if (this.state.selectedUsers.length > 0) {
      this.setState({ selectedUsers: [] });
    } else {
      this.setState({ selectedUsers: this.props.company.users.filter((u) => !u.disabled) });
    }
  };

  toggleCal = (type) => {
    if (type == "list") {
      this.setState({
        selectedTempIndex:
          this.state.selectedTempIndex.length > 0
            ? [this.state.selectedTempIndex[0]]
            : [0],
        showCal: type,
      });
    }
    if (type == "planner") {
      if (this.props.company.users.length > 0) {
        this.setState({
          selectedUsers: [this.props.company.users[0]],
          showCal: type,
        });
      } else {
        this.setState({
          selectedUsers: [],
          showCal: type,
        });
      }
    } else {
      this.setState({
        showCal: type,
      });
    }
  };

  updateshowAdd = (showAdd) => {
    if (showAdd) {
      // Save scroll positions of all columns and horizontal container before opening appointment
      const scrollPositions = {};
      const columns = document.querySelectorAll('.direct-chat-messages');
      columns.forEach((col) => {
        if (col.id) {
          scrollPositions[col.id] = col.scrollTop;
        }
      });
      // Save horizontal scroll position
      const kanbanContainer = document.getElementById('kanban-container');
      const horizontalScroll = kanbanContainer ? kanbanContainer.scrollLeft : 0;
      this.setState({
        showAdd,
        savedScrollPositions: scrollPositions,
        savedHorizontalScroll: horizontalScroll
      });
    } else {
      // Close appointment and restore scroll positions after render
      this.setState({ showAdd }, () => {
        setTimeout(() => {
          const { savedScrollPositions, savedHorizontalScroll } = this.state;
          // Restore column scroll positions
          Object.keys(savedScrollPositions).forEach((id) => {
            const col = document.getElementById(id);
            if (col) {
              col.scrollTop = savedScrollPositions[id];
            }
          });
          // Restore horizontal scroll position
          const kanbanContainer = document.getElementById('kanban-container');
          if (kanbanContainer) {
            kanbanContainer.scrollLeft = savedHorizontalScroll;
          }
        }, 0);
      });
    }
  };
  componentDidMount() {
    this.props.dispatchGetActiveJobs();
  }

  componentDidUpdate(prevProps, prevState) {
    // The company (and its users/templates) loads asynchronously. On a hard
    // refresh it isn't ready when this component constructs, so setUsers()/
    // setStatuses() return [] and the empty user filter hides every job.
    // Re-seed the filter the moment the company's users first arrive.
    const users = (this.props.company && this.props.company.users) || [];
    const prevUsers = (prevProps.company && prevProps.company.users) || [];
    if (users.length && !prevUsers.length) {
      // Company just became available. The initial componentDidMount fetch fired
      // before selectedCompanyId was set (so it returned nothing); re-fetch now.
      if (!this.props.activeJobs || !this.props.activeJobs.length) {
        this.props.dispatchGetActiveJobs();
      }
      if (this.state.selectedUsers.length === 0) {
        this.setState({ selectedUsers: users.filter((u) => !u.disabled) });
      }
    }
    if (
      this.props.templates && this.props.templates.length &&
      (!prevProps.templates || !prevProps.templates.length) &&
      this.state.selectedStatuses.length === 0
    ) {
      this.setState({ selectedStatuses: this.setStatuses() });
    }

    if (
      JSON.stringify(prevProps.activeJobs) !=
        JSON.stringify(this.state.activeJobs) ||
      (this.props.activeJobs.length > 0 &&
        JSON.stringify(this.state.activeJobs) == JSON.stringify([]))
    ) {
      this.setState({
        activeJobs: [...this.props.activeJobs],
      });
    }

    return true;
  }

  countStatusItems = (status, t) => {
    let total = 0;

    this.state.selectedTempIndex.forEach((element) => {
      let items = t.filter(
        (i) => i.appointmentType == this.props.templates[element].name
      );
      if (status == "All") return (total += items.length);
      else if (status == "Unscheduled")
        total += items.filter(
          (i) => !(i.hasSchedule == undefined || i.hasSchedule == true)
        ).length;
      else if (status == "Scheduled")
        total += items.filter(
          (i) =>
            (i.hasSchedule == undefined || i.hasSchedule == true) &&
            (i.status ?? "Scheduled") == "Scheduled"
        ).length;
      else total += items.filter((i) => i.status == status).length;
    });
    return `${total}`;
  };

  onDragStart = (event, taskId) => {
    event.dataTransfer.setData("taskId", taskId);
  };
  onDragOver = (event) => {
    event.preventDefault();
  };

  onDrop = (event, cat) => {
    let taskId = event.dataTransfer.getData("taskId");

    // console.log('taskId', taskId);
    let tasks = this.props.activeJobs.filter((task) => {
      if (task._id == taskId) {
        task.hasSchedule = cat !== "Unscheduled";
        task.status = cat;

        this.props.dispatchSetAppointment(task);
      }
      return task;
    });

    this.setState({
      ...this.state,
      tasks,
    });
  };

  OnAssign = (userId, appointment) => {
    let tasks = this.state.activeJobs.filter((task) => {
      if (task._id == appointment._id) {
        task.userId = userId;
        this.props.dispatchSetAppointment(task);
      }
      return task;
    });

    this.setState({
      ...this.state,
      tasks,
    });
  };

  toggleSortBy = () => {
    this.setState((prevState) => ({
      sortBy: prevState.sortBy === "importance" ? "id" : "importance",
    }));
  };

  handleStatusColorChange = (statusName, color) => {
    // Find the template that contains this status
    const template = this.props.templates.find(t =>
      t.statuses && t.statuses.some(s => s.name === statusName)
    );

    if (template) {
      // Update the status color
      const updatedTemplate = {
        ...template,
        statuses: template.statuses.map(s =>
          s.name === statusName ? { ...s, color } : s
        )
      };
      // Save the updated template
      this.props.dispatchUpdateTemplate(updatedTemplate);
    }
  };

  render() {
    const component1 = (status, t) => {
      return (
        <span className="badge badge-danger">
          {this.countStatusItems(status, t)}
        </span>
      );
    };

    const but = (status, t, hide) => {
      return {
        element: component1(status, t),
        status,
        hide,
      };
    };

    let buttons = ["Unscheduled"];

    let filteredInvoices = this.state.activeJobs ?? [];

    if (!!this.props.search) {
      filteredInvoices = filteredInvoices.filter((i) => {
        if (i.clientName) {
          return i.clientName
            .toLowerCase()
            .includes(this.props.search.toLowerCase());
        }
        return false;
      });
    }

    if (this.props.company && this.props.company.users) {
      filteredInvoices = filteredInvoices.filter((i) => {
        return !!this.state.selectedUsers.find((u) => u.userId == i.userId);
      });
    }

    let templateButtons =
      this.props.templates && this.props.templates.length > 0
        ? this.props.templates.map((i) => {
            return {
              name: i.name,
              _statuses: i.statuses ?? [],
              components: i.components,
              statuses: i.statuses
                ? [
                    but("Unscheduled", filteredInvoices, false),
                    ...i.statuses.map((t) =>
                      but(t.name, filteredInvoices, !!t.hide)
                    ),
                  ]
                : [],
              items: filteredInvoices.filter(
                (o) => o.appointmentType == i.name
              ),
              count: filteredInvoices.filter((o) => o.appointmentType == i.name)
                .length,
            };
          })
        : [];

    //
    let selectedTemplate = null;
    if (this.state.selectedTempIndex.length > 0) {
      buttons = [];
      filteredInvoices = [];

      this.state.selectedTempIndex.forEach((element) => {
        let currentTemplate = templateButtons[element];

        selectedTemplate = {
          _statuses: selectedTemplate
            ? [...selectedTemplate._statuses, ...currentTemplate._statuses]
            : currentTemplate._statuses,
        };
        buttons = [...new Set([...buttons, ...currentTemplate.statuses])];
        filteredInvoices = [...filteredInvoices, ...currentTemplate.items];
      });
    }

    const getItemStatus = (item) => {
      return item.hasSchedule == undefined || item.hasSchedule == true
        ? item.status ?? "Scheduled"
        : "Unscheduled";
    };

    const getColor = (temp, s) => {
      if (temp) {
        let ss = temp._statuses.find((o) => o.name == s);
        if (ss) {
          return ss.color ?? colors.primary;
        }
      }
      return colors.primary;
    };

    const _all = this.state.activeJobs || [];
    const heroCnt = {
      scheduled: _all.filter((i) => i.hasSchedule === undefined || i.hasSchedule === true).length,
      unscheduled: _all.filter((i) => !(i.hasSchedule === undefined || i.hasSchedule === true)).length,
      attention: _all.filter((i) => (i.hasSchedule === undefined || i.hasSchedule === true) && i.startDate && moment(i.startDate) < moment()).length,
    };
    const calInitials = (nm) => (nm || "?").split(" ").filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase();
    const calAv = (nm) => { let h = 0; for (let c = 0; c < (nm || "").length; c++) h = (h * 31 + nm.charCodeAt(c)) % 6; return h; };

    return (
      <div className="content-wrapper accent-calendar">
        <SpinnerView showSpinner={this.props.loading} />

        {this.state.showAdd && selectedTemplate && (
          <Appointment updateshowAdd={this.updateshowAdd} />
        )}

        {!this.state.showAdd && (
          <div style={{ padding: "4px 6px 0" }}>
            {/* Hero */}
            <div className="cal-hero">
              <div className="cal-hero-row">
                <div>
                  <div className="cal-hero-title">Job Board</div>
                  <div className="cal-hero-sub">
                    <span className="cal-chip-stat"><i className="fas fa-circle" style={{ fontSize: 5 }}></i> {heroCnt.scheduled} scheduled</span>
                    {heroCnt.attention > 0 && <span className="cal-chip-stat attn"><i className="fas fa-triangle-exclamation" style={{ fontSize: 8 }}></i> {heroCnt.attention} overdue</span>}
                    <span className="cal-chip-stat"><i className="fas fa-clock-rotate-left" style={{ fontSize: 8 }}></i> {heroCnt.unscheduled} unscheduled</span>
                  </div>
                </div>
                <div className="cal-hero-actions">
                  <div className="cal-view-toggle">
                    <button className={this.state.showCal === "list" ? "active" : ""} onClick={() => this.toggleCal("list")}><i className="fas fa-table-columns"></i> Board</button>
                    <button className={this.state.showCal === "planner" ? "active" : ""} onClick={() => this.toggleCal("planner")}><i className="fas fa-route"></i> Planner</button>
                  </div>
                  <Link to="/calendar" className="cal-ghost-btn" title="Switch to the Calendar"><i className="far fa-calendar"></i> Calendar</Link>
                  <button className="cal-add-btn" onClick={() => { this.props.dispatchSelectAppointment(undefined); this.updateshowAdd(true); }}><i className="fas fa-plus"></i> New appointment</button>
                </div>
              </div>
            </div>

            {/* Filter row */}
            <div className="cal-filter-row">
              {templateButtons.length > 0 && (
                <div className="cal-seg">
                  {templateButtons.map((i, k) => (
                    <button key={k} className={this.state.selectedTempIndex.includes(k) ? "active" : ""} onClick={() => this.updateTempIndex(k)}>
                      {i.name} <span style={{ opacity: 0.55 }}>{i.count}</span>
                    </button>
                  ))}
                </div>
              )}

              <div className="cal-filter-search">
                <i className="fas fa-magnifying-glass"></i>
                <input placeholder="Filter cards…" value={this.props.search || ""} onChange={(e) => this.props.dispatchEnterSearch(e.target.value)} />
              </div>

              {this.props.company && this.props.company.users && this.props.company.users.filter((u) => !u.disabled).map((i) => (
                <button key={i.userId} className={`cal-chip ${this.state.selectedUsers.find((o) => o.userId == i.userId) ? "active" : ""}`} onClick={() => this.updateSelectedUsers(i.userId)}>
                  <i className="fas fa-user"></i> {i.name}
                </button>
              ))}
              {this.props.company && this.props.company.users && this.props.company.users.length > 0 && (
                <button className="cal-chip" onClick={() => this.toggleSelectedUsers()}>Toggle all</button>
              )}

              {this.state.showCal === "planner" && this.props.templates &&
                [...new Set(this.props.templates.flatMap((x) => x.statuses.filter((x) => !x.hide).map((y) => y.name)))].map((i, k) => (
                  <button key={"s" + k} className={`cal-chip ${this.state.selectedStatuses.find((o) => o == i) ? "active" : ""}`} onClick={() => this.updateSelectedStatuses(i)}>{i}</button>
                ))}

              {this.state.showCal === "list" && (
                <button className="cal-chip" onClick={this.toggleSortBy}><i className="fas fa-sort"></i> Sort: {this.state.sortBy === "importance" ? "Importance" : "ID"}</button>
              )}
            </div>
          </div>
        )}

        {!this.state.showAdd && <div style={{ padding: '12px 6px 16px' }}>

          <div id="kanban-container" style={{ overflowX: "auto" }}>
            {this.state.showCal == "planner" &&
              this.state.selectedUsers.length > 0 && (
                <Planner
                  selectedUser={this.state.selectedUsers[0]}
                  dispatchSelectAppointment={
                    this.props.dispatchSelectAppointment
                  }
                  events={filteredInvoices
                    .filter(
                      (i) => i.hasSchedule == undefined || i.hasSchedule == true
                    )
                    .filter((i) =>
                      this.state.selectedStatuses.includes(getItemStatus(i))
                    )}
                  updateshowAdd={this.updateshowAdd}
                  statuses={this.state.selectedStatuses}
                />
              )}

            <div className={this.state.showCal == "list" ? "cal-board" : "row"}>
              {this.state.showCal != "planner" &&
                buttons.map((m) => {
                  const colColor = m.status == "Unscheduled" ? "var(--text-muted)" : getColor(selectedTemplate, m.status);
                  return (
                    <div
                      key={m.status}
                      className="cal-col"
                      style={{
                        ["--col-accent"]: colColor,
                        height: "calc(100vh - 300px)",
                        opacity: m.hide ? 0.6 : 1,
                        ...(this.state.showCal == "list" ? {} : { flex: 1, maxWidth: "none" }),
                      }}
                      onDragOver={(event) => this.onDragOver(event)}
                      onDrop={(event) => { this.onDrop(event, m.status); }}
                    >
                      <div className="cal-col-head">
                        <div className="cal-col-icon">
                          <i className={m.status == "Unscheduled" ? "fas fa-clock-rotate-left" : "fas fa-circle"} style={{ fontSize: m.status == "Unscheduled" ? 10 : 7 }}></i>
                        </div>
                        <div className="cal-col-title">{m.status}</div>
                        <span className="cal-col-count">{this.countStatusItems(m.status, filteredInvoices)}</span>
                        <span style={{ position: "relative" }}>
                          <button
                            type="button"
                            className="cal-col-dot"
                            data-toggle="dropdown"
                            aria-expanded="false"
                            style={{ color: colColor }}
                            onClick={(e) => e.stopPropagation()}
                            title="Column colour"
                          >
                            <i className="fas fa-palette"></i>
                          </button>
                          <div className="dropdown-menu dropdown-menu-right">
                            {[["Blue", "#2563EB"], ["Teal", "#0DA1B2"], ["Green", "#1B9F69"], ["Amber", "#E5A000"], ["Red", "#DA4A4F"], ["Gray", "#6c757d"]].map(([label, hex]) => (
                              <a key={hex} className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); this.handleStatusColorChange(m.status, hex); }}>
                                <i className="fas fa-square" style={{ color: hex, marginRight: 8 }}></i> {label}
                              </a>
                            ))}
                          </div>
                        </span>
                      </div>
                      <div
                        className="cal-col-body"
                        id={m.status == "Unscheduled" ? "external-events" : m.status + "_"}
                      >
                          {filteredInvoices
                            .filter(
                              (i) =>
                                (i.hasSchedule == undefined ||
                                i.hasSchedule == true
                                  ? i.status ?? "Scheduled"
                                  : "Unscheduled") == m.status
                            )
                            .sort(
                              function (a, b) {
                                if (this.state.sortBy === "id") {
                                  // Sort by item ID
                                  return a._id.localeCompare(b._id);
                                } else {
                                  // Sort by importance (original sorting logic)
                                  if (m.status != "Unscheduled") {
                                    if (a.priority == b.priority) {
                                      if (
                                        moment(a.startDate) <
                                        moment(b.startDate)
                                      )
                                        return -1;
                                      else return 1;
                                    } else {
                                      let aP =
                                        a.priority == "Critical"
                                          ? 5
                                          : a.priority == "High"
                                          ? 4
                                          : a.priority == "Medium"
                                          ? 3
                                          : a.priority == "Low"
                                          ? 2
                                          : 0;
                                      let bP =
                                        b.priority == "Critical"
                                          ? 5
                                          : b.priority == "High"
                                          ? 4
                                          : b.priority == "Medium"
                                          ? 3
                                          : b.priority == "Low"
                                          ? 2
                                          : 0;

                                      return aP > bP ? -1 : 1;
                                    }
                                  } else {
                                    if (a.priority == b.priority) {
                                      if (a.clientName < b.clientName)
                                        return -1;
                                      else return 1;
                                    } else {
                                      let aP =
                                        a.priority == "Critical"
                                          ? 5
                                          : a.priority == "High"
                                          ? 4
                                          : a.priority == "Medium"
                                          ? 3
                                          : a.priority == "Low"
                                          ? 2
                                          : 0;
                                      let bP =
                                        b.priority == "Critical"
                                          ? 5
                                          : b.priority == "High"
                                          ? 4
                                          : b.priority == "Medium"
                                          ? 3
                                          : b.priority == "Low"
                                          ? 2
                                          : 0;

                                      return aP > bP ? -1 : 1;
                                    }
                                  }
                                }
                              }.bind(this)
                            )
                            .map((item) => {
                              const userObj = (this.props.company && this.props.company.users && this.props.company.users.find((u) => u.userId == item.userId)) || {};
                              const assignee = userObj.name;
                              const grp = userObj.group;
                              const scheduled = item.hasSchedule == undefined || item.hasSchedule == true;
                              const late = scheduled && item.startDate && moment(item.startDate) < moment();
                              const prio = (item.priority || "").toLowerCase();
                              const desc = item.faultDescription || item.name;
                              const updated = (item.log && item.log.length)
                                ? item.log.reduce((mx, l) => (l.d && moment(l.d).isAfter(mx) ? moment(l.d) : mx), moment(item.createdDate))
                                : null;
                              const endValid = item.endDate && moment(item.endDate).year() > 1971 && moment(item.endDate).isAfter(moment(item.startDate));
                              const durDays = endValid ? Math.max(1, Math.ceil(moment(item.endDate).diff(moment(item.startDate), "days", true))) : null;
                              return (
                                <div
                                  key={item._id}
                                  draggable
                                  id={item._id}
                                  title={item.name}
                                  className={`cal-job ${m.status == "Unscheduled" ? "external-event" : ""} ${prio ? "prio-" + prio : ""}`}
                                  onDragStart={(event) => this.onDragStart(event, item._id)}
                                  onClick={() => { this.props.dispatchSelectAppointment(item); this.updateshowAdd(true); }}
                                >
                                  <div className="cal-job-head">
                                    <div className={`cal-job-av cal-av-${calAv(item.clientName)}`}>{calInitials(item.clientName)}</div>
                                    <div className="cal-job-client">
                                      <div className="name">{item.clientName || "—"}</div>
                                      <div className="sub">{item.appointmentType}{grp ? " · " + grp : ""}</div>
                                    </div>
                                    {item.appointmentNumber && <span className="cal-job-num">#{item.appointmentNumber}</span>}
                                  </div>
                                  {desc ? <div className="cal-job-title">{desc.substring(0, 90)}</div> : null}
                                  <div className="cal-job-ago">
                                    <span><i className="far fa-circle-plus"></i> {moment(item.createdDate).fromNow()}</span>
                                    {updated ? <span><i className="far fa-pen-to-square"></i> {updated.fromNow()}</span> : null}
                                  </div>
                                  <div className="cal-job-foot">
                                    {prio ? <span className={`cal-prio cal-prio-${prio}`}><i className="fas fa-flag"></i> {item.priority}</span> : null}
                                    {scheduled
                                      ? <span className={`cal-meta-chip ${late ? "late" : ""}`}><i className="far fa-clock"></i> {moment(item.startDate).format("DD MMM")}</span>
                                      : <span className="cal-meta-chip"><i className="fas fa-clock-rotate-left"></i> Unscheduled</span>}
                                    {durDays ? <span className="cal-meta-chip"><i className="far fa-hourglass-half"></i> {durDays} day{durDays > 1 ? "s" : ""}</span> : null}
                                    {item.invoiceId ? <span className="cal-meta-chip ok"><i className="fas fa-file-invoice"></i> Invoiced</span> : null}
                                    {assignee ? <span className="cal-meta-chip assignee"><i className="fas fa-user-check"></i> {assignee}</span> : null}
                                  </div>
                                </div>
                              );
                            })}
                      </div>
                    </div>
                  );
                })}

            </div>
          </div>
        </div>}
      </div>
    );
  }
}

export default HomeView;
